"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.autoReadSMS = autoReadSMS;
function autoReadSMS(cb) {
    // used AbortController with setTimeout so that WebOTP API (Autoread sms) will get disabled after 1min
    const signal = new AbortController();
    setTimeout(() => {
        signal.abort();
    }, 1 * 60 * 1000);
    function main() {
        return __awaiter(this, void 0, void 0, function* () {
            if ('OTPCredential' in window) {
                try {
                    if (navigator.credentials) {
                        try {
                            yield navigator.credentials
                                .get({ abort: signal, otp: { transport: ['sms'] } })
                                .then((content) => {
                                if (content && content.code) {
                                    cb(content.code);
                                }
                            })
                                .catch(e => console.log(e));
                        }
                        catch (e) {
                            return;
                        }
                    }
                }
                catch (err) {
                    console.log(err);
                }
            }
        });
    }
    main();
}
//# sourceMappingURL=utils.js.map